/**
 * Compile-time environment for the RC configuration.
 * See environment.dev.ts for the policy on URLs vs. secrets.
 */
import type { Environment } from './environment.types';

export type {
  MsalConfig,
  GoogleSSOConfig,
  AppleSSOConfig,
  FeatureFlags,
  Environment,
} from './environment.types';

import { SHARED_AUTHORITY, SHARED_SSO } from './environment.shared';

export const environment: Environment = {
  production: true,
  environmentName: 'RC',
  apiUrl: 'https://rc.gtlcapi.ca/rest/gtlc-cms_rc',
  redirectUrl: 'https://rc.parent.gtlc.ca',
  assetsBaseUrl: 'https://rc.gtlcapi.ca/assets',
  uploadUrl: 'https://rc.gtlcapi.ca/uploads',
  wsServer: 'wss://rc.gtlcapi.ca/ws/websocket',
  msal: {
    clientId: SHARED_SSO.msal.clientId,
    authority: SHARED_AUTHORITY,
    tenantId: SHARED_SSO.msal.tenantId,
    redirectUri: 'https://rc.parent.gtlc.ca',
    postLogoutRedirectUri: 'https://rc.parent.gtlc.ca',
    scopes: [...SHARED_SSO.msal.scopes],
    apiScope: SHARED_SSO.msal.apiScope,
  },
  google: {
    clientId: SHARED_SSO.google.clientId,
    redirectUri: 'https://rc.parent.gtlc.ca',
    scopes: [...SHARED_SSO.google.scopes],
  },
  apple: {
    clientId: SHARED_SSO.apple.clientId,
    redirectUri: 'https://rc.parent.gtlc.ca',
    scopes: [...SHARED_SSO.apple.scopes],
  },
  features: {
    debugLogging: false,
    experimental: false,
  },
};
